var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.625C14.4871 18.625 18.125 14.9871 18.125 10.5C18.125 6.01289 14.4871 2.375 10 2.375C5.51289 2.375 1.875 6.01289 1.875 10.5C1.875 14.9871 5.51289 18.625 10 18.625ZM6.43125 10.3184C6.48906 10.2601 6.55778 10.2138 6.63349 10.182C6.70921 10.1503 6.79043 10.1338 6.87251 10.1335C6.9546 10.1332 7.03595 10.149 7.11191 10.1801C7.18788 10.2112 7.25697 10.257 7.31523 10.3148L9.375 12.3586V7.14062C9.375 6.97486 9.44085 6.81589 9.55806 6.69868C9.67527 6.58147 9.83424 6.51562 10 6.51562C10.1658 6.51562 10.3247 6.58147 10.4419 6.69868C10.5592 6.81589 10.625 6.97486 10.625 7.14062V12.3586L12.6848 10.3148C12.8026 10.1981 12.9619 10.1329 13.1278 10.1336C13.2936 10.1344 13.4524 10.201 13.5691 10.3187C13.6859 10.4365 13.7511 10.5959 13.7503 10.7617C13.7496 10.9276 13.683 11.0864 13.5652 11.2031L10.4402 14.3043C10.3232 14.4205 10.1649 14.4857 10 14.4857C9.83507 14.4857 9.67683 14.4205 9.55977 14.3043L6.43477 11.2031C6.37637 11.1453 6.32994 11.0765 6.29815 11.0007C6.26636 10.925 6.24983 10.8437 6.24951 10.7615C6.24918 10.6793 6.26506 10.5979 6.29625 10.5218C6.32744 10.4458 6.37331 10.3766 6.43125 10.3184Z",
    fill: "#A5AEBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownCircle);
export default __webpack_public_path__ + "static/media/arrow-down-circle.9d64cc685d1e2bdbc26104205c5eded8.svg";
export { ForwardRef as ReactComponent };